module.exports = __webpack_public_path__ + "static/media/pentaho.243a38bc.svg";